import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityAttendance } from "../../entity/EntityAttendance";

export class DtoAttendancesPutReq extends EntityAttendance {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_attendance_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
